<template>
    <div class="animated fadeIn">
        <b-card class="card-accent-info" header="Obras">          
            <b-card-body>
                <b-row>
                    <b-col cols="auto" class="mr-auto">
                    </b-col>
    
                    <b-col cols="auto" class="">
                        <b-form-group>
                            <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)" v-if="$store.state.currentUser.username !== 'estagiario'"><i class="fa fa-plus"></i><span>Nova Obra</span></b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Empresa</label>
                            <b-form-select v-model="filters.companyId" id="filterCompany" :plain="true" :options="this.companyDDL" @change="changeCompany()">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="name" style="font-size: 0.8em">Filtro</label>
                            <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Tipo de Obra</label>
                            <b-form-select v-model="filters.projectTypeId" id="filterProjectType" :plain="true" :options="this.filterProjectTypeDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>

                    <b-col cols="auto">
                        <b-form-group>
                            <label for="startDate" style="font-size: 0.8em">Período</label>
                            <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="startDate">&nbsp;&nbsp;&nbsp;</label>
                            <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Status</label>
                            <b-form-select v-model="filters.statusId" id="filterStatus" :plain="true" :options="this.projectStatusDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                        <b-form-group>
                            <p></p>
                            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="auto" class="">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Linhas</label>
                            <b-form-select v-model="perPage" id="perPage" :plain="true" :options="[5,10,20,50]">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
    
                <b-table :items="filteredItems" :fields="fields" :select-mode="selectMode" responsive="sm" ref="selectableTable" selectable @row-selected="onRowSelected" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left @row-clicked="rowClicked"
                    :per-page="perPage" :current-page="currentPage" :busy="isBusy" hover striped sort-by="id" :sort-desc=true>

                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                          <span aria-hidden="true">&check;</span>
                          <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                          <span aria-hidden="true">&nbsp;</span>
                          <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                      
                    <template #cell(show_details)="row">
                        <b-row>
                            <b-col cols="auto" class="mr-auto">
                                <b-form-group>
                                    <b-button size="sm" variant="primary" @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </template>
                                    
                    <template #row-details="row">
                        <b-card>
                            <b-row>
                                <b-col class="small">Contato</b-col>
                                <b-col class="text-primary">{{ row.item.contact }}</b-col>
                                <b-col class="small">Telefone</b-col>
                                <b-col class="text-primary">{{ row.item.phone1 }}</b-col>
                                <b-col class="small">E-mail</b-col>
                                <b-col class="text-primary">{{ row.item.email }}</b-col>
                            </b-row>
                        
                            <b-row v-show="row.item.address && row.item.address.length > 0">
                                <b-col class="small">Endereço</b-col>
                            </b-row>
                        
                            <b-row>
                                <b-col class="text-primary">{{ row.item.address }} {{ row.item.addressNumber ? ", " + row.item.addressNumber : ""}}
                                    <br>{{ row.item.complement ? row.item.complement + " - " : "" }} {{ row.item.district }}
                                    <br>{{ row.item.city }} - {{ row.item.stateCode }}
                                    <br>CEP: {{ row.item.zipCode }}
                                </b-col>
                            </b-row>
                        
                            <b-row>
                                <b-col class="small">Documentos e Formulários</b-col>
                            </b-row>
                        
                            <b-row v-if="projectReport">
                                <b-col v-for="report in projectReport" :key="report.id" cols="3" style="padding: 10px 10px 10px 10px;">
                                    <b-button block :variant="report.colorButton && report.colorButton != '' ? report.colorButton : 'github'" class="mr-1 btn-brand" @click="openModalPDF(row.item.id, report.id)">{{ report.name }}</b-button>
                                </b-col>
                        
                            </b-row>
                        
                        </b-card>
                    </template>
                                    
                    <template v-slot:cell(originalValue)="data">
                        {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                    </template>

                    <template v-slot:cell(paymentValue)="data">
                        {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                    </template>

                    <template v-slot:cell(costcenter)="data">
                        {{ data.item.costCenterCode }}<br>{{ data.item.costCenterName }}
                    </template>

                    <template v-slot:cell(clone)="data">
                        <b-button size="sm" variant="primary" @click="clone(data.item)" class="mr-1 btn-brand" title="Clonar">
                        <i class="fa fa-clone"></i></b-button>
                    </template>

                    <template v-slot:cell(action)="data">
                          <b-button size="sm" variant="primary" @click="clone(data.item)" class="mr-1 btn-brand" title="Clonar" style="margin-bottom: 4px" v-if="$store.state.currentUser.username !== 'estagiario'">
                          <i class="fa fa-clone"></i></b-button>
                          <b-button size="sm" variant="css3" @click="openCommentModal(data.item)" class="mr-1 btn-brand" title="Comentário" style="margin-bottom: 4px">
                          <i class="fa fa-comment"></i></b-button>
                          <b-button size="sm" variant="dropbox" @click="openActionModal(data.item)" class="mr-1 btn-brand" title="Ação" style="margin-bottom: 4px" v-if="$store.state.currentUser.username !== 'estagiario'">
                          <i class="fa fa-tasks"></i></b-button>
                          <b-button size="sm" variant="linkedin" @click="openImageModal(data.item)" class="mr-1 btn-brand" title="Arquivos" style="margin-bottom: 4px">
                          <i class="fa fa-file-image-o"></i></b-button>
                          <b-button size="sm" variant="primary" @click="openProductModal(data.item)" class="mr-1 btn-brand" title="Itens" style="margin-bottom: 4px" v-if="$store.state.currentUser.username !== 'estagiario'">
                          <i class="fa fa-money"></i></b-button>
                         
                          
                    </template>

                    <template v-slot:cell(name)="data">
                        {{ data.item.name }}<br>
                        <span class="text-primary" v-if="data.item.description">{{ data.item.description }} <br></span>
                        <span class="text-primary" v-if="data.item.contact">{{ data.item.contact + " | Tel: " + data.item.phone1}}<br></span>
                        <span class="text-danger" v-if="data.item.notes">{{ data.item.notes }} <br></span>
                        
                    </template>

                    <template v-slot:cell(code)="data">
                        <span class="text-primary" v-if="data.item.erpCode">{{ data.item.erpCode }} <br></span>
                        {{ data.item.code }}<br>                        
                    </template>

                    <template v-slot:cell(startDate)="data">
                        {{ $utils.dateStringFormat(data.item.startDate) }}                        
                    </template>

                      
                    <template v-slot:cell(approveVehicle)="data">
                        <b-button v-if="data.item.vehiclePlate" size="sm" :variant="data.item.vehicleApprovalBy && data.item.vehicleApprovalBy > 1 ? 'success' : checkVehicleRestriction(data.item.vehiclePlate, data.item.startDate) ? 'primary' : 'danger'" @click="approveVehicle(data.item)" class="mr-1 btn-brand" title="Aprovar veículo">
                            <i class="fa fa-car"></i></b-button>
                    </template>
                      
                    <template v-slot:cell(st)="data">
                        <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                    
                    <template v-slot:cell(ispublic)="data">
                        <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                    
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>

        </b-card-body>
     </b-card>

     <b-modal
              v-model="productModal"
              id="product-modal"
              centered
              hide-footer
              title="Produtos e Serviços"
              size="xl">

              <project-prospect-component
                :companyId = "filters.companyId"
                :projectId = "selectedItem.id"
                :projectName = "selectedItem.name"
              ></project-prospect-component>

    </b-modal>

     <b-modal
              v-model="imageModal"
              id="image-modal"
              centered
              hide-footer
              title="Arquivos do Obra"
              size="xl">
     
            <div class="row text-center text-lg-start" v-if="projectImages && projectImages.length > 0">
              <div class="col-lg-3 col-md-4 col-6" v-for="item in projectImages" :key="item.id">
                <a href="#" class="d-block mb-4 h-100">
                  <img class="img-fluid img-thumbnail" :src="item.url" alt="" @click="openFileModal(item)"><br>
                  <b-button size="sm" variant="danger" @click="deleteFile(item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>
                </a>
               
              </div>            
            </div>

            <div class="container" v-else>
                  <div class="row">
                      <div class="col-12" style="height: 100px">
                          <h3 class="gallery-title">Nenhum arquivo disponível</h3>
                      </div>
                  </div>
            </div>
      
            <b-card v-show="projectDocs">
              <b-table :items="projectDocs" :fields="fileFields" :select-mode="fileSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
                      per-page="50" current-page="1" :busy="isBusyFile" hover striped>
                    

                <template #table-busy>

                  <div class="text-center text-danger my-2">

                      <b-spinner class="align-middle"></b-spinner>

                      <strong>Carregando...</strong>

                  </div>
                </template>
                              
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    
                                      <span aria-hidden="true">&check;</span>
                    
                                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template v-slot:cell(createdIn)="data">
                    {{ $utils.localDateTimeShort( data.item.createdIn ) }}
                </template>

                <template v-slot:cell(action)="data">
                  <b-button size="sm" variant="primary" @click="openFileModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                  
                </template>

                <template v-slot:cell(action2)="data">
                  <b-button size="sm" variant="danger" @click="deleteFile(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>
                </template>


              </b-table>
            </b-card>

            <b-card>
              <b-form @submit.stop.prevent="onSubmit">

                <div class="d-flex mb-3">
                    <file-drop-area-component v-model="fileToSend" class="w-100"></file-drop-area-component>
                </div>
                <p></p>
                <div class="d-flex mb-3  justify-content-center">
                    <b-button :disabled="!fileToSend" variant="primary" @click="uploadFile">Enviar Arquivo</b-button>
                </div>    

                </b-form>
            </b-card>

     </b-modal>
  
     <b-modal
              v-model="itemModal"
              id="item-modal"
              centered
              hide-footer
              title="Obra"
              size="lg">

          <b-card header="Itens / Produtos">
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>

            <b-row>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Status</label>
                            <b-form-select v-model="editStatusId" id="filterStatus" :plain="true" :options="this.statusDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
            </b-row>     
       

            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveAction()"><i class="fa fa-check"></i><span>Salvar Atendimento</span></b-button>
            
            </div>

          </b-card>

     </b-modal>

     
     
     <b-modal v-model="actionModal"
              id="action-modal"
              centered
              hide-footer
              title="Atendimento"
              size="lg">

          <b-card>
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>

            <b-row>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Status</label>
                            <b-form-select v-model="editStatusId" id="filterStatus" :plain="true" :options="this.editStatusDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
            </b-row>     
       

            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveAction()"><i class="fa fa-check"></i><span>Salvar Atendimento</span></b-button>
            
            </div>

          </b-card>

     </b-modal>


     <b-modal
              v-model="commentModal"
              id="comments-modal"
              centered
              hide-footer
              title="Comentário"
              size="lg">

          <b-card>
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>


            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveComment()"><i class="fa fa-check"></i><span>Salvar Comentário</span></b-button>
            
            </div>

          </b-card>

     </b-modal>


     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Obra"
              size="lg">
  

              <b-nav fill>
            <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Projeto</b-nav-item>
            <b-nav-item :active="tabInfo=='R'" @click="tabInfo='R'">Documentos e Formulários</b-nav-item>
            <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>
            <b-nav-item :active="tabInfo=='A'" @click="tabInfo='A'" v-if="false">Aprovadores</b-nav-item>
          </b-nav>

          <div v-show="tabInfo=='R'">
            <b-card>   

              <b-card header="Documentos e Formulários">
                <b-row v-for="report in projectReport" :key="report.id" style="padding-top: 10px">
                  <b-col cols="6">
                    <b-button block :variant="report.colorButton && report.colorButton != '' ? report.colorButton : 'github'" class="mr-1 btn-brand" @click="openModalPDF(selectedItem.id, report.id)" ><span>{{ report.name }}</span></b-button>
                  </b-col>
                </b-row>                
              </b-card>

            </b-card>
          </div>


          <div v-show="tabInfo=='H'">
            <b-card>   
              
                    
              <b-row>
                  <b-col md="12">
                  
                    <b-table :items="projectDetail" :fields="projectDetailFields" :select-mode="projectDetailSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left 
    
                    per-page="50" current-page="1" :busy="isBusyProjectDetail" hover striped>
    
                      <template #table-busy>
      
                        <div class="text-center text-danger my-2">
      
                            <b-spinner class="align-middle"></b-spinner>
      
                            <strong>Carregando...</strong>
      
                        </div>
                      </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                      <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                          
                                            <span aria-hidden="true">&check;</span>
                          
                                            <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                          <span aria-hidden="true">&nbsp;</span>
                          
                          <span class="sr-only">Not selected</span>
                      </template>
                                    </template>
                      <template v-slot:cell(createdIn)="data">
                          {{ $utils.localDateTimeShort( data.item.createdIn ) }}
                      </template>
                                                          
                      <template v-slot:cell(templateDescription)="data">
                          <span class="text-primary">{{ data.item.detailTypeName }}</span><br>
                          {{ data.item.description }}
                      </template>

                    </b-table>
                    
                  </b-col>
                </b-row>


            </b-card>
          </div>

          <div v-show="tabInfo=='P'">
            <b-card>   

                <b-form @submit.stop.prevent="onSubmit">
          
                <div class="animated fadeIn">
              
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Id"
                        label-for="id"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col>
                              <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
                            </b-col>
                            <b-col cols="12" md="auto">
                              Código:
                            </b-col>
                            <b-col>
                                 
                                  <b-form-input v-model="selectedItem.code" id="code" type="text"></b-form-input>
                            </b-col>
                          </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                   
                  </b-row>
          <!--                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Empresa"
                        label-for="company"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="company"
                          :plain="true"
                          :options="[
                            { value: null, text: '- Empresa -' },
                            { value: 1, text: 'A6i' },
                            { value: 111, text: 'Tecnovale Gás' }

                          ]"
                          value="Empresa">
                        </b-form-select>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
-->

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Field"
                        label-for="erpCode"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col>
                              <b-form-input v-model="selectedItem.erpCode" id="erpCode" type="text"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="auto">
                              Unidade:
                            </b-col>
                            <b-col>
                              <b-form-select id="branchCode"
                                v-model="selectedItem.branchCode"
                                :plain="true"
                                :options="this.branchDDL"
                                >
                              </b-form-select>
                            </b-col>
                            
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="CNPJ/CPF"
                        label-for="doc"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col>
                              <b-form>
                                <b-form-group>
                                <b-input-group style="width: 210px">
                                    <b-input-group-append><b-input-group-text><i class="fa fa-id-card"></i></b-input-group-text></b-input-group-append>
                                    <masked-input
                                      type="text"
                                      name="doc"
                                      class="form-control cols-md-2"
                                      v-model="selectedItem.customerDoc"
                                      :mask="selectedItem && selectedItem.customerDoc && selectedItem.customerDoc.length > 14 ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/] : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]"
                                      :guide="false"
                                      placeholderChar="#">
                                    </masked-input>
                                  </b-input-group>
                                </b-form-group>          
                              </b-form>
                            </b-col>
                            
                            
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Cliente"
                        label-for="customer"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.name" id="customer" type="text"></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>


                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Endereço"
                        label-for="address"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col cols="7">
                              <b-form-input v-model="selectedItem.address" id="address" type="text"></b-form-input>
                            </b-col>
                            <b-col cols="2">
                              Número:
                            </b-col>
                            <b-col cols="3">
                              <b-form-input v-model="selectedItem.addressNumber" id="address_number" type="text"></b-form-input>
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                   
                  </b-row>

                  
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Complemento"
                        label-for="complement"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col>
                              <b-form-input v-model="selectedItem.complement" id="complement" type="text"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="auto">
                              Bairro:
                            </b-col>
                            <b-col>
                              <b-form-input v-model="selectedItem.district" id="district" type="text"></b-form-input>
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                   
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="CEP"
                        label-for="zipCode"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col cols="5">
                              <b-form-group>
                                <b-input-group style="width: 210px">
                                    <b-input-group-append><b-input-group-text><i class="fa fa-inbox"></i></b-input-group-text></b-input-group-append>
                                    <masked-input
                                      type="text"
                                      name="doc"
                                      class="form-control cols-md-2"
                                      v-model="selectedItem.zipCode"
                                      :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                                      :guide="false"
                                      placeholderChar="#"
                                      v-on:keyup="getZipCode(selectedItem.zipCode)"
                                      >
                                    </masked-input>
                                  </b-input-group>
                                </b-form-group>          
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>                   
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Cidade"
                        label-for="city"
                        :label-cols="3"
                        :horizontal="true">


                        <b-row>
                          <b-col>
                            <b-form-select id="city"
                            v-model="selectedItem.cityId"
                            :plain="true"
                            :options="this.cityDDL"
                            value="Cidade">
                          </b-form-select>
                          </b-col>
                          <b-col cols="12" md="auto">
                            Estado
                          </b-col>
                          <b-col>
                            <b-form-select id="state"
                              v-model="selectedItem.stateId"
                              :plain="true"
                              :options="this.stateDDL"
                              >
                            </b-form-select>
                          </b-col>
                        </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <hr>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Contato"
                        label-for="project"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.contact" id="project" type="text"></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="E-mail"
                        label-for="email"
                        :label-cols="3"
                        :horizontal="true">
                        <div>
                          
                          <b-input-group>
                            <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                            <b-form-input v-model="selectedItem.email" type="email" placeholder="E-mail" autocomplete="email"></b-form-input>
                            
                          </b-input-group>
                        </div>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Telefone celular"
                        label-for="phone1"
                        :label-cols="3"
                        :horizontal="true">
                        
                        <b-row>
                          <b-col cols="6">
                            <b-input-group >
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class='fa fa-mobile-phone'></i>
                                </span>
                              </div>
                              <masked-input
                                type="tel"
                                name="phone1"
                                class="form-control"
                                v-model="selectedItem.phone1"
                                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                :guide="false"
                                placeholderChar="#">
                              </masked-input>
                            </b-input-group>
                          </b-col>
                          <b-col cols="6">
                            <b-input-group >
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class='fa fa-mobile-phone'></i>
                                </span>
                              </div>
                              <masked-input
                                type="tel"
                                name="phone1"
                                class="form-control"
                                v-model="selectedItem.phone2"
                                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                :guide="false"
                                placeholderChar="#">
                              </masked-input>
                            </b-input-group>
                          </b-col>
                          
                        </b-row>
                        
                        
                        
                      </b-form-group>          
                      </b-form>
                    
                    </b-col>
                  </b-row>

                  <hr>

               
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Descrição"
                        label-for="description"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-textarea
                          id="description"
                          v-model="selectedItem.description"
                          placeholder=""
                          rows="3"
                        ></b-form-textarea>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
          
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Orientação"
                        label-for="orientation"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-textarea
                          id="orientation"
                          v-model="selectedItem.orientation"
                          placeholder=""
                          rows="3"
                        ></b-form-textarea>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
          

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Observação"
                        label-for="observation"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-textarea
                          id="observation"
                          v-model="selectedItem.observation"
                          placeholder=""
                          rows="3"
                        ></b-form-textarea>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
          
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Tipo de Obra"
                        label-for="type"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="type"
                          v-model="selectedItem.typeId"
                          :plain="true"
                          :options="this.projectTypeDDL"
                          value=""
                          @change="refreshByProjectType(selectedItem.typeId)"
                          >
                        </b-form-select>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Setor"
                        label-for="sector"
                        :label-cols="3"
                        :horizontal="true">


                        <b-row>
                          <b-col>
                            <b-form-select id="sector"
                            v-model="selectedItem.sectorId"
                            :plain="true"
                            :options="projectSectorDDL"
                            value="Setor">
                          </b-form-select>
                          </b-col>
                          <b-col cols="12" md="auto">
                            Ocorrência
                          </b-col>
                          <b-col>
                            <b-form-select id="occurrence"
                              v-model="selectedItem.occurrenceId"
                              :plain="true"
                              :options="projectOccurrenceDDL"
                              value="">
                            </b-form-select>
                          </b-col>
                        </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
               

                  <hr>

                  <b-form-group
                    label="Data de início"
                    label-for="startDate"
                    :label-cols="3"
                    :horizontal="true">
                    <b-row>
                      <b-col>
                        <b-form-input v-model="selectedItem.startDate" type="date" id="startDate"></b-form-input>
                      </b-col>
                      <b-col cols="2">
                        Término
                      </b-col>
                      <b-col>
                        <b-form-input v-model="selectedItem.endDate" type="date" id="endDate"></b-form-input>
                      </b-col>
                    </b-row>
                    
                  </b-form-group>
                  

                  <hr>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Equipamento"
                        label-for="equipment"
                        :label-cols="3"
                        :horizontal="true">


                        <b-row>
                          <b-col>
                            <b-form-select id="equipment"
                            v-model = "selectedItem.equipmentId"
                            :plain="true"
                            :options="projectEquipmentDDL"
                            value="">
                          </b-form-select>
                          </b-col>
                          <b-col cols="2">
                            Serial
                          </b-col>
                          <b-col cols="5">
                            <b-form-input v-model="selectedItem.equipmentSerial" id="serial" type="text"></b-form-input>
                          </b-col>
                        </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>
               
                  
                  <hr>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Observação de trabalho"
                        label-for="notes"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-textarea
                          id="notes"
                          v-model="selectedItem.notes"
                          placeholder=""
                          rows="3"
                        ></b-form-textarea>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

          
                  <b-input-group class="mb-4">
                      <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                  </b-input-group>
                
                  <div slot="footer" class="text-right" v-if="$store.state.currentUser.username !== 'estagiario'">
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Obra</span></b-button>                  
                  </div>
                        
                </div>
                </b-form>
              </b-card>
            </div>

            
          <div v-show="tabInfo=='A'">
            <b-card>

              <b-form @submit.stop.prevent="onSubmit">
                <div class="animated fadeIn">
            
                  <b-card header="Aprovador Técnico">

                    <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="E-mail"
                        label-for="email"
                        :label-cols="3"
                        :horizontal="true">
                        <div>
                          
                          <b-input-group>
                            <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                            <b-form-input v-model="selectedItem.techmanagermail" type="email" placeholder="E-mail" autocomplete="email"></b-form-input>
                            
                          </b-input-group>
                        </div>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Modelo de e-mail"
                        label-for="techtemplateid"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="type"
                          v-model="selectedItem.techTemplateId"
                          :plain="true"
                          :options="this.templateDDL"
                          value=""
                          >
                        </b-form-select>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                </b-card>

                  <b-card header="Aprovador Compras">
                    <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="E-mail"
                        label-for="email"
                        :label-cols="3"
                        :horizontal="true">
                        <div>
                          
                          <b-input-group>
                            <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                            <b-form-input v-model="selectedItem.purchasingmanagermail" type="email" placeholder="E-mail" autocomplete="email"></b-form-input>
                            
                          </b-input-group>
                        </div>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Modelo de e-mail"
                        label-for="purchasingtemplateid"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="type"
                          v-model="selectedItem.purchasingTemplateId"
                          :plain="true"
                          :options="this.templateDDL"
                          value=""
                          >
                        </b-form-select>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>


                </b-card>

                  <b-card header="Aprovador Financeiro">
                    <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="E-mail"
                        label-for="email"
                        :label-cols="3"
                        :horizontal="true">
                        <div>
                          
                          <b-input-group>
                            <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                            <b-form-input v-model="selectedItem.financemanagermail" type="email" placeholder="E-mail" autocomplete="email"></b-form-input>
                            
                          </b-input-group>
                        </div>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Modelo de e-mail"
                        label-for="financetemplateid"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="type"
                          v-model="selectedItem.financeTemplateId"
                          :plain="true"
                          :options="this.templateDDL"
                          value=""
                          >
                        </b-form-select>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>


                 

                </b-card>
                  
                <b-input-group class="mb-4">
                      <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                  </b-input-group>
                
                  <div slot="footer" class="text-right">
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Obra</span></b-button>
                  
                  </div>

                </div>
              </b-form>
            </b-card>
          </div>

      </b-modal>
  
      
      <b-modal title="Documentos e Formulários" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
          <div class="ratio ratio-16x9">
              <iframe
              :src="this.selectedDocument"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>


      <b-modal :title="selectedFile.filename" class="modal-danger" v-model="fileModal" @ok="fileModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedFile">
          <div class="ratio ratio-16x9">
           
              <iframe
              :src="this.selectedFile.url"
              :title="this.selectedFile.filename"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>

      
    </div>
  
  </template>
  
<script>
import Vue from 'vue'

import ProjectProspectComponent from './ProjectProspectComponent.vue'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import axios from "axios";
import MaskedInput from 'vue-text-mask'
import VueSimpleAlert from "vue-simple-alert";

import { Switch as cSwitch } from '@coreui/vue'
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr' // https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
Vue.use(VueSimpleAlert);
Vue.use(VueQuillEditor)

/* Toast - End */

const newItem = { id: null, name: '', companyId: 0, description: '', st: 'A', _rowVariant: '', address: null, typeId: null, sectorId: null }

export default {
    name: 'tables',
    components: {
        Event,
        cSwitch,
        MaskedInput,
        ProjectProspectComponent,
        FileDropAreaComponent
    },
    data: () => {
        return {


          // Modal dos arquivos não Imagem
          selectedFile: null,
          fileModal: false,

          isBusyFile: false,
          fileItems: [],
          fileFields: [
            { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
            { key: 'filename', label: 'Arquivo', sortable: true },
            { key: 'description', label: 'Descrição', sortable: true},
            { key: 'action2', label: '', sortable: false, thStyle: { width: "40px" } },
            
          ],
          fileSelectMode: 'single',


            fileToSend: null,
             // Tabela Histórico
            isBusyProjectDetail: false,
            projectDetailFields: [
              { key: 'createdIn', label: 'Data', sortable: true, thStyle: { width: "100px" }, class: 'text-center'},
              { key: 'templateDescription', label: 'Descrição', sortable: true },
              //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
            ],
            projectDetailSelectMode: 'single',
            projectDetail: [],
            projectFiles: [],
            commentContent: '',

            branchDDL: [
              { value: '', text: '' },
              { value: 'MAUA', text: 'MAUA' },
              { value: 'SJC', text: 'SJC' }
            ],

            projectReport: [],

            productModal: false,

            itemModal: false,
            imageModal: false,
            actionModal: false,
            commentModal: false,
            documentModal: false,
            selectedDocument: null,

            projectStatusDDL: [],
            statusFullDDL: [],
            templateDDL: [],
            companyDDL: [],
            stateDDL: [],
            cityDDL: [],
            projectTypeDDL: [],
            projectSectorDDL: [],
            projectOccurrenceDDL: [],
            projectEquipmentDDL: [],
            teamDDL: [],
            vehicleDDL: [],

            tabInfo: 'P',

            isBusy: false,
            currentPage: 1,
            switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
            switchLabelTxt: {
                dataOn: 'yes',
                dataOff: 'no'
            },

            tableRef: "table",
            tableSelectable: false,
            errorMessage: '',

            editStatusId: 1,
            editModal: false,
            filters: {
                companyId: 0,
                key: '',
                startDate: null,
                endDate: null,
                statusId: 0,
                projectTypeId: 0
            },

            modes: ['multi', 'single', 'range'],
            selectMode: 'multi',
            selected: [],
            transProps: {
                // Transition name
                name: 'flip-list'
            },
            primaryKey: "id",

            selectedItem: newItem,
            items: [],
            fields: [
                
                { key: 'show_details', label: "", thStyle: { width: "40px" } },
                {key: 'id', label: 'Id', sortable: true, thStyle: { width: "15px" }, tdClass: 'align-middle' },
                { key: 'code', label: 'Código', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
                { key: 'name', label: 'Obra', sortable: true },
                { key: 'startDate', label: 'Início', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
                {key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
                { key: 'action', label: '', sortable: false, thStyle: { width: "120px" } },
            ],

            filterable: ['username'],
            sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' },
            perPage: 20
        }
    },
    computed: {

        projectImages() {
          var list = this.projectFiles.filter(item => {
              return item.typeId == 1
          })
          return list;
        },

        projectDocs() {
          var list = this.projectFiles.filter(item => {
              return item.typeId != 1
          })
          return list;
        },

        editStatusDDL() {
          var list = this.statusFullDDL.filter(item => {
              return item.parent.includes(1)
          })
          return list;
        },

        filterProjectTypeDDL() {
          var list = [...this.projectTypeDDL]
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
        },

        statusDDL() {

            var list = [...this.statusFullDDL]

            list = list.filter(item => {
              return !item.nextStatusId;
            })
            list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)

            list.unshift({ value: 'F' , text: '- Fechados -' })
            list.unshift({ value: 'C' , text: '- Cancelados -' })
            list.unshift({ value: 'A' , text: '- Abertos -' })
            list.unshift({ value: '0' , text: '- Todos -' })

            return list
 
        },
        totalRows: function() { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                  return(
                    (this.filters.statusId == 0 || item.statusId == this.filters.statusId || item.mainStatusId == this.filters.statusId))
                    && (this.filters.key == '' || 
                      (
                        item.id == this.filters.key
                        || item.erpCode == this.filters.key
                        || this.$utils.filterString(item.name, this.filters.key)
                        || this.$utils.filterString(item.address, this.filters.key)
                        || this.$utils.filterString(item.zipCode.replace('.','').replace('-',''), this.filters.key)
                      )
                    )
                  
                })
            } catch (e) {
                return this.items;
            }
        }
    },
    methods: {

      async deleteFile(item) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        axios.delete(
          this.$store.state.ws_url + "/project/file?projectFileId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.getProjectFiles(s.selectedItem)
          toast({
              type: VueNotifications.types.info,
              title: 'Arquivo',
              message: "Arquivo excluído.",
              timeout: 5000
          })
        }).catch(function(error) {
          console.log(error)
          toast({
              type: VueNotifications.types.error,
              title: 'Arquivo',
              message: "Erro ao excluir arquivo.",
              timeout: 5000
          })
        })

      },

      async uploadFile() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        let formData = new FormData();

        formData.append('companyId', this.filters.companyId)
        formData.append('projectId', this.selectedItem.id)
        formData.append('file', this.fileToSend);
        formData.append('uid', currentUser.id);
        formData.append('sid', currentUser.sid);

        await axios.post(
            this.$store.state.ws_url + "/project/file/upload", formData
        ).then(function(resp) {
          s.fileToSend = null
          s.getProjectFiles(s.selectedItem)
          toast({
              type: VueNotifications.types.info,
              title: 'Arquivo',
              message: "Arquivo salvo com sucesso",
              timeout: 5000
          })
          
        }).catch(function (error) {
          console.log(error);
        });

      },

      async saveAction() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          if(this.selectedItem != null && this.commentContent != null && this.commentContent.length > 0)  {
            var postData = { projectId: this.selectedItem.id, statusId: 5, description: this.commentContent, uid: currentUser.id, sid: currentUser.sid, statusId: this.editStatusId }

            await axios.post(
                  this.$store.state.ws_url + "/project/action",
                  postData
              ).then(function (resp) {
                  s.closeActionModal();
                  s.refreshData();
              }
              ).catch(function (error) {
                  console.log("ERRO")
                  console.log(error.message);
                
              });
          }
          else {
            toast({
                        type: VueNotifications.types.warn,
                        title: 'Ação',
                        message: "Entre com uma observação antes de salvar.",
                        timeout: 5000
                    })
          }

        },

        async saveComment() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          if(this.selectedItem != null && this.commentContent != null && this.commentContent.length > 0)  {
            var postData = { projectId: this.selectedItem.id, statusId: 5, description: this.commentContent, uid: currentUser.id, sid: currentUser.sid }

            await axios.post(
                  this.$store.state.ws_url + "/project/action",
                  postData
              ).then(function (resp) {
                  s.closeCommentModal();
              }
              ).catch(function (error) {
                  console.log("ERRO")
                  console.log(error.message);
                
              });
          }
          else {
            toast({
                        type: VueNotifications.types.warn,
                        title: 'Comentário',
                        message: "Entre com um comentário antes de salvar.",
                        timeout: 5000
                    })
          }

        },

        approveVehicle(item) {

          console.log("Verificando restrição:");

          if(item.vehicleApprovalId && vehicleApprovalId > 0) {
            // Já aprovadp
            this.$alert("Veículo já aprovado por " + item.vehicleApprovalName + " em " + item.vehicleApprovalIn + ".");
          }
          else {
            // Aprovação  
            var vehicleRestricted = this.checkVehicleRestriction(item.vehiclePlate, item.startDate)
            var msg;
            if(!vehicleRestricted) {
              msg = "Deseja aprovar veículo " + item.vehiclePlate + " em dia de rodízio?";
            }
            else {
              msg = "Deseja aprovar veículo " + item.vehiclePlate + "?"
            }

            this.$confirm(msg).then(() => {
                  console.log("Inicio da aprovação do veículo...")
              }).catch(function(error) {

              });
          }

        },
        clone(item) {

            this.$confirm("Deseja realmente clonar o item?").then(() => {
                this.selectedItem = { ...item }
                this.selectedItem.id = null;
                this.selectedItem.code = null;
                this.selectedItem.vehicleApprovalId = null;
                this.selectedItem.vehicleApprovalIn = null;
                this.selectedItem.startDate = this.$utils.dateFormat(new Date());
                this.selectedItem.endDate = null;


                this.editModal = true;

                toast({
                        type: VueNotifications.types.success,
                        title: 'Clone',
                        message: "Obra clonada. Salve após efetuar as alterações desejadas.",
                        timeout: 5000
                    })
            }).catch(function(error) {

            }) ;

            
            /*
            var dialog = confirm("Deseja realmente clonar o item?");
            if(dialog) {
              console.log("Inicio da clonagem...")
            }
            */

        },

        openProductModal(selectedItem) {
          this.selectedItem = selectedItem
          this.productModal = true
        },

        closeProductModal() {
          this.productModal = false
        },

        openFileModal(item) {
              this.selectedFile = item;
              this.fileModal=true;
        },

        
        openModalPDF(projectId, reportId) {
            var currentUser = this.$store.state.currentUser;
            this.selectedDocument = this.$store.state.ws_url + "/project/report/pdf?projectId=" + projectId + "&reportId=" + reportId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid;

            this.documentModal = true;
        },
        getRowCount: function() {
            return this.items.length
        },
        submit() {

        },
        async saveItem(currentItem) {

            var s = this;
            var postData = { ...currentItem };

            postData["companyId"] = s.filters.companyId
            postData["uid"] = this.$store.state.currentUser.id
            postData["sid"] = this.$store.state.currentUser.sid
            postData.startDate = postData.startDate + "T12:00:00.000Z"
            if (postData.endDate) {
                postData.endDate = postData.endDate + "T12:00:00.000Z"
            }
            
            await axios.post(
                this.$store.state.ws_url + "/project",
                postData
            ).then(function(resp) {
                s.closeEditModal(resp)
                s.refreshData();
            }).catch(function(error) {
                console.log(error);

                toast({
                    type: VueNotifications.types.warn,
                    title: 'Obra',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })
            });

        },

        save() {

          let msgError = [];

          if(!this.selectedItem.typeId || this.selectedItem.typeId <= 0)
              msgError.push("Tipo de Projeto");
          if(!this.selectedItem.name || this.selectedItem.name.length <= 0)
              msgError.push("Cliente")
         
          if(msgError.length > 0) {
              let msgErrorExt = "Verifique os campos: ";
              let msgErrorSep = "";
              msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

              toast ({
                  type: VueNotifications.types.error,
                  title: 'Campos Obrigatórios',
                  message: msgErrorExt,
                  timeout: 5000
              })
          }
          else {
              this.saveItem(this.selectedItem);
          }
        },
      
        
        enableDisable() {
            console.log('Habilitando/desabilitando modelo')
            console.log(this.selectedItem);
        },

        closeItemModal() {
          this.itemModal = false;
        },
        openItemModal(item) {
          this.fileToSend = null;
          this.itemModal = true;
        },

        closeImageModal() {
          this.imageModal = false;
          
        },
        openImageModal(item) {
          this.selectedItem = item;
          this.getProjectFiles(item);
          this.imageModal = true;
        },

        closeCommentModal() {
          this.commentModal = false;
        },
        openCommentModal(item) {
          this.selectedItem = item
          this.commentContent = null;
          this.commentModal = true;
        },

        closeActionModal() {
          this.actionModal = false;
        },

        openActionModal(item) {
          this.selectedItem = item
          this.editStatusId = item.statusId
          this.actionModal = true
        },

        closeEditModal() {
            this.editModal = false;
        },
        openEditModal(item) {
            if (item == null) {
                this.selectedItem = { ...newItem };
                this.selectedItem.companyId = this.filters.companyId
                this.selectedItem.cityId = this.$store.state.config.cityId
                this.selectedItem.stateId = this.$store.state.config.stateId
                var now = new Date();
                
                this.selectedItem.startDate = this.$utils.dateFormat(new Date());
                this.projectDetail = []

            } else {
                this.selectedItem = JSON.parse(JSON.stringify(item));
                this.refreshByProjectType(this.selectedItem.typeId);
                this.getProjectDetail(item);
            }
            this.editModal = true;
        },
        onRowSelected(items) {
            /*
            if(item == null) {
                this.selectedItem = newItem;      
            }
            else {
                this.selectedItem = JSON.parse(JSON.stringify(item));
            }
            this.selected = items
            */
            //console.log(items);
            //this.openEditModal(items[0])
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },
        clearSelectedRows() {
            this.$refs.selectableTable.clearSelected();
        },
        rowClicked(item) {
            if (!this.tableSelectable) {
                this.clearSelectedRows();
                this.openEditModal(item);
            }
        },
        getBadge(status) {
            return status === 'A' ? 'primary' :
                status === 'I' ? 'danger' :
                status === 'Pending' ? 'warning' :
                status === 'Banned' ? 'danger' : 'primary'
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },

        async getZipCode(zipCode) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            zipCode = zipCode.replace(/\D/g, "");

            if (zipCode.length >= 8) {
                await axios.get(
                    this.$store.state.ws_url + "/utils/cep/" + zipCode

                ).then(function(resp) {
                  if (resp.data.obj) {
                        s.selectedItem.address = resp.data.obj.logradouro;
                        s.selectedItem.district = resp.data.obj.bairro;

                        if (s.selectedItem.stateId != resp.data.obj.stateId) {
                            s.selectedItem.stateId = resp.data.obj.stateId
                            s.getCity(s.$store.state.config.countryId, resp.data.obj.stateId);
                        }
                        s.selectedItem.cityId = resp.data.obj.cityId
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
               
            }

        },

        async getCity(countryId, stateId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/city/ddl?countryId=" + countryId + "&stateId=" + stateId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
              s.cityDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
          
        },
        async getState(countryId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/state/ddl?countryId=" + countryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.stateDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
           
        },
        async getProjectOccurrence(projectTypeId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/project/occurrence/ddl?projectTypeId=" + projectTypeId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.projectOccurrenceDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },
        async getProjectSector(projectTypeId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/project/sector/ddl?projectTypeId=" + projectTypeId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.projectSectorDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
           
        },
        
        async getEquipment(companyId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/project/equipment/ddl?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.projectEquipmentDDL = resp.data.obj;
            }).catch(function(error) {
                console.log(error);
            });
          
        },
        async getProjectType(companyId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/project/type/ddl?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.projectTypeDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });            
        },
        async getProjectReport(companyId) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/project/report/list?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.projectReport = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            });
        },

        async getStatus() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
          
            await axios.get(
                this.$store.state.ws_url + "/project/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
                s.statusFullDDL = resp.data.obj;
            })            
            .catch(function(error) {
                console.log(error);
            });
            
        },

        async getProjectStatus() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
          
            await axios.get(
                this.$store.state.ws_url + "/project/status/ddl?companyId=" + s.filters.companyId + "&group=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.projectStatusDDL = resp.data.obj
            })            
            .catch(function(error) {
                console.log(error);
            });
            
        },

        async getProjectFiles(item) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/project/file?projectId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.projectFiles = resp.data.obj;
          }).catch(function(error) {
            console.log(e)
          })
          ;
          this.isBusy = false;
        },


        async getProjectDetail(item) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/project/detail?projectId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.projectDetail = resp.data.obj;
          }).catch(function(errro) {
            console.log(e)
          })
          ;
          this.isBusy = false;
        },

        async refreshData() {
           
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/project?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid +
                (s.filters.startDate ? "&startDate=" + s.filters.startDate : "") +
                (s.filters.endDate ? "&endDate=" + s.filters.endDate : "") +
                (s.filters.key ? "&key=" + encodeURI(s.filters.key) : "") +
                (s.filters.projectTypeId ? "&projectTypeId=" + s.filters.projectTypeId : "")
            ).then(function(resp) {
              s.items = resp.data.obj;
            }).catch(function(errro) {
              console.log(e)
            })
            this.isBusy = false;
           
        },

        refreshByProjectType(projectTypeId) {
            if (projectTypeId && projectTypeId > 0) {
                this.getProjectOccurrence(projectTypeId);
                this.getProjectSector(projectTypeId);
            }
        },

        changeCompany() {
          var companyId = this.filters.companyId
          this.getProjectReport(companyId);
          this.getProjectType(companyId);
          this.getEquipment(companyId);
          this.refreshData();
        },

        stringToDate(dateStr) {
          return new Date( dateStr.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3") + "T12:00:00Z" );
        },

        checkVehicleRestriction(licensePlate, date) {
            //console.log("Verificando: " + licensePlate + " data: " + date + " - " + typeof date)

            var currentDate = new Date();

            if(date) {
              if(typeof date === "string")
                currentDate = this.stringToDate(date)
              else
              if(typeof date === "Date")
                currentDate = date;
            }

            if (licensePlate) {
                
                const weekDay = currentDate.getDay();
                // Verifique se é fim de semana
                
                //console.log("uai so.." + currentDate + " weekday: " + weekDay)

                if (weekDay === 0 || weekDay === 6) {
                    return true;
                }
                const lastDigit = parseInt(licensePlate.slice(-1));

                //console.log("Placa: " + licensePlate + " " + weekDay + " - " + lastDigit)

                switch (weekDay) {
                    case 1: // Segunda-feira
                        return lastDigit !== 1 && lastDigit !== 2;
                    case 2: // Terça-feira
                        return lastDigit !== 3 && lastDigit !== 4;
                    case 3: // Quarta-feira
                        return lastDigit !== 5 && lastDigit !== 6;
                    case 4: // Quinta-feira
                        return lastDigit !== 7 && lastDigit !== 8;
                    case 5: // Sexta-feira
                        return lastDigit !== 9 && lastDigit !== 0;
                    default:
                        return true; // Pode circular nos outros dias
                }
            }
            else {
              //console.log("Não é placa???" + typeof licensePlate)
            }

        }

    },

    mounted: function() {
        this.companyDDL = this.$store.state.currentUser.companies
        var companyId = this.$store.state.config.companyId
        this.filters.companyId = companyId
        this.filters.projectTypeId = 0
        this.isBusy = true

        var now = new Date();

        // Primeiro dia
        this.filters.startDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() - 3, 1))
        // Último dia
        this.filters.endDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() + 1, 0))

        this.getStatus()
        this.getProjectStatus()
        this.getState(this.$store.state.config.countryId);
        this.getCity(this.$store.state.config.countryId, (this.selectedItem.stateId ? this.selectedItem.stateId : this.$store.state.config.stateId));
        this.changeCompany();

        this.refreshData();
    }
}
</script>
  
<style scoped>
table#table-transition-example .flip-list-move {
    transition: transform 1s;
}

.flex-column { 
       max-width : 260px;
   }
   .container {
            background: #f9f9f9;
        }
      
        img {
            margin: 5px;
        }

.col-12 img {
  opacity: 1;
  cursor: pointer;
  margin: 2rem;
  width: 100%;
}

.col-12 img:hover {
  opacity: 1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>